import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-makepayment',
  templateUrl: './makepayment.component.html',
  styleUrls: ['./makepayment.component.css']
})
export class MakepaymentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
